<template>    
    <v-card>
        <!-- Titulo del dialogo -->
        <v-card-title>
            Añadir Influencer
            <v-spacer></v-spacer>
            <v-select class="mr-6 ml-12" :disabled="editedItem.department==''" v-show="permissions('assignInfluencers')" v-model="editedItem.parent_id" :items="talentsAgentList" item-value="id" item-text="name" label="Talent Agent"></v-select>
            <v-select class="mr-6" v-model="editedItem.department" :items="bookingList" label="Departamento"></v-select>
        </v-card-title>
        <v-divider></v-divider>
            <!-- Formulario -->
        <v-form ref="form">
            <v-stepper v-model="e1" class="elevation-0">
                <v-stepper-header class="elevation-0">
                    <v-stepper-step style="font-weight:bolder!important;" :complete="e1 > 1" step="1"></v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step style="font-weight:bolder!important;" step="2"></v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step style="font-weight:bolder!important;" step="3"></v-stepper-step>
                </v-stepper-header>
                <v-stepper-items>
                    <v-stepper-content step="1" class="pt-0">
                        <v-row class="py-3 px-6"> 
                            <v-col cols="12" sm="6" md="6" class="py-0">
                                <v-text-field :rules="[v => !!v || 'Campo requerido']" v-model="editedItem.name" label="Nombre"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6" class="py-0">
                                <v-text-field v-model="editedItem.last" label="Apellido"></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="6" md="6" class="py-0">
                                <v-text-field v-model="editedItem.email" label="Email"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6" class="py-0">
                                <v-text-field v-model="editedItem.phone" label="Teléfono"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6" class="py-0">
                                <v-select v-model="state" :items="statesList" item-value="id" item-text="name" label="Estado"></v-select>
                            </v-col>
                            <v-col cols="12" sm="6" md="6" class="py-0">
                                <v-select :disabled="state==undefined || state=='' || state==null" v-model="editedItem.city" :items="citiesList" item-value="id" item-text="name" label="Ciudad"></v-select>
                            </v-col>

                            <v-col cols="12" sm="6" md="6" class="py-0">
                                <v-menu>
                                    <template v-slot:activator="{ on }">
                                        <v-text-field v-model="editedItem.birth_date" label="Cumpleaños" prepend-icon="mdi-calendar" readonly v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker color="primary" v-model="editedItem.birth_date" @input="datePicker = false"></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="12" sm="6" md="6" class="py-0">
                                <v-text-field v-model="editedItem.address" label="Dirección"></v-text-field>
                            </v-col>

                            <!--v-col cols="12" sm="6" md="6" class="py-0">
                                <v-text-field prefix="@" v-model="editedItem.social_networks.facebook" label="Facebook"></v-text-field>
                            </v-col-->
                            <v-col cols="12" sm="6" md="6" class="py-0">
                                <v-text-field prefix="@" v-model="editedItem.social_networks.instagram" label="Instagram"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6" class="py-0">
                                <v-text-field prefix="@" v-model="editedItem.social_networks.tiktok" label="TikTok"></v-text-field>
                            </v-col>
                            <!--v-col cols="12" sm="6" md="6" class="py-0">
                                <v-text-field prefix="@" v-model="editedItem.social_networks.twitter" label="Twitter"></v-text-field>
                            </v-col-->

                            <v-col cols="12" sm="6" md="6" class="py-0">
                                <v-text-field prefix="#" v-model="editedItem.instagram_followers" label="Instagram Followers"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6" class="py-0">
                                <v-text-field prefix="#" v-model="editedItem.tiktok_followers" label="TikTok Followers"></v-text-field>
                            </v-col>

                        </v-row>
                    </v-stepper-content>
                    <v-stepper-content step="2" class="pt-0">
                        <v-row class="py-3 px-6"> 
                            <v-col cols="12" sm="4" md="6" class="py-0">
                                <v-text-field v-model="editedItem.bank_account_details.bank" label="Banco"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="4" md="6" class="py-0">
                                <v-text-field v-model="editedItem.bank_account_details.account" label="Numero de Cuenta"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="4" md="6" class="py-0">
                                <v-text-field v-model="editedItem.bank_account_details.clabe" label="Clabe Interbancaria"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="4" md="6" class="py-0">
                                <v-text-field v-model="editedItem.bank_account_details.tarejta" label="Tarjeta"></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="4" md="6" class="py-0">
                                <v-text-field v-model="editedItem.commission_percentage" suffix="%" label="Porcentaje Comisión" v-if="!editedItem.is_booking"></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="4" md="6" class="py-0">
                                <v-autocomplete class="mb-0 pb-0" v-model="editedItem.tax_regime_id" :items="regimes" item-value="id" item-text="regime" label="Régimen Fiscal"></v-autocomplete>
                            </v-col>

                            <v-col cols="12" sm="4" md="6" class="py-0">
                                <v-text-field class="mb-0 pb-0" v-model="editedItem.rfc" label="RFC o CUPR"></v-text-field>
                            </v-col>
                            
                            <v-col cols="12" sm="4" md="6" class="py-0">
                                <v-file-input
                                    v-model="fileInputs.cdf"
                                    label="CDF"
                                    accept=".pdf,.jpg,.png"
                                    prepend-icon="mdi-paperclip"
                                    @change="uploadFile($event, 'cdf')"
                                    @click:clear="clearFile('cdf')"
                                />
                            </v-col>

                            <v-col cols="12" sm="4" md="6" class="py-0">
                                <v-file-input
                                    v-model="fileInputs.ine"
                                    label="INE"
                                    accept=".pdf,.jpg,.png"
                                    prepend-icon="mdi-paperclip"
                                    @change="uploadFile($event, 'ine')"
                                    @click:clear="clearFile('ine')"
                                />
                            </v-col>

                            <v-col cols="12" sm="4" md="6" class="py-0">
                                <v-file-input
                                    v-model="fileInputs.pasaporte"
                                    label="Pasaporte"
                                    accept=".pdf,.jpg,.png"
                                    prepend-icon="mdi-paperclip"
                                    @change="uploadFile($event, 'pasaporte')"
                                    @click:clear="clearFile('pasaporte')"
                                />
                            </v-col>

                            <v-col cols="12" sm="4" md="6" class="py-0">
                                <v-file-input
                                    v-model="fileInputs.visa"
                                    label="Visa"
                                    accept=".pdf,.jpg,.png"
                                    prepend-icon="mdi-paperclip"
                                    @change="uploadFile($event, 'visa')"
                                    @click:clear="clearFile('visa')"
                                />
                            </v-col>

                            <v-col cols="12" sm="4" md="6" class="py-0">
                                <v-file-input
                                    v-model="fileInputs.comprobante_domicilio"
                                    label="Comprobante de Domicilio"
                                    accept=".pdf,.jpg,.png"
                                    prepend-icon="mdi-paperclip"
                                    @change="uploadFile($event, 'comprobante_domicilio')"
                                    @click:clear="clearFile('comprobante_domicilio')"
                                />
                            </v-col>
                        </v-row>
                    </v-stepper-content>

                    <v-stepper-content step="3" class="pt-0">
                        <v-card-title class="mb-0 pb-0">Tallas</v-card-title>
                        <v-row class="ma-0 mt-2 px-2" v-for="(talla, index) in editedItem.tallas" :key="index">
                            <v-col cols="5" class="py-0">
                                <v-text-field label="Etiqueta" v-model="talla.label"></v-text-field>
                            </v-col>
                            <v-col cols="5" class="py-0">
                                <v-text-field label="Valor" v-model="talla.value"></v-text-field>
                            </v-col>
                            <v-col cols="2" class="pt-3">
                                <v-row class="ma-0">
                                    <v-btn @click="removeTalla(index)" icon v-if="editedItem.tallas.length>1"><v-icon>mdi-delete</v-icon></v-btn>
                                    <v-spacer v-if="index>0"/>
                                    <v-btn @click="addTalla(index)" icon><v-icon>mdi-plus</v-icon></v-btn>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-stepper-content>

                    <!--v-stepper-content step="2" class="pt-0">
                    <Servicios
                        <v-row style="background-color: #94949417;" class="px-2 ma-0 py-2 mt-2" v-for="(service,k) in editedItem.services" :key="k">
                            <v-col ols="12" sm ="8" md="6" class="py-0 my-0">
                                <v-text-field v-model="service.service" label="Servicio"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm ="8" md="4" class="py-0 my-0">
                                <v-text-field v-model="service.price" prefix="$" suffix="c/u" label="Precio"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm ="4" md="2">
                                <v-icon @click="remove(k)" v-show="k || ( !k && editedItem.services.length > 1)" color="red">mdi-close</v-icon>
                                <v-icon @click="add(k)" v-show="k == editedItem.services.length-1" color="primary">mdi-plus</v-icon>
                            </v-col>
                        </v-row>
                    </v-stepper-content-->
                </v-stepper-items>
            </v-stepper>
        </v-form>
        

        <v-card-actions class="pt-4">
            <v-autocomplete class="mb-0 pb-0" v-model="editedItem.category_ids" small-chips :items="categories" item-value="id" item-text="name" label="Categoría(s)" multiple chips></v-autocomplete>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="close">
                Cancelar
            </v-btn>
            <v-btn color="blue darken-1" text  v-if="e1>1" @click="e1 = e1-1">
                <v-icon v-if="!isMobile()">mdi-chevron-left</v-icon>
                Regresar
            </v-btn>
            <v-btn color="blue darken-1" text  v-if="e1!=3" @click="e1 = e1+1">
                Siguiente
                <v-icon v-if="!isMobile()">mdi-chevron-right</v-icon>
            </v-btn>
            <v-btn color="blue darken-1" text :disabled="valid" @click="save">
                Guardar
            </v-btn>
        </v-card-actions>
        <v-snackbar :color="snackbar.color" v-model="snackbar.show" style="text-align:center;">
            <strong>{{ snackbar.message }}</strong>
        </v-snackbar>

    </v-card>
</template>
<script>
import axios from "axios";
export default {
    data:()=>({ 
        fileInputs: {
            cdf: null,
            ine: null,
            pasaporte: null,
            visa: null,
            comprobante_domicilio: null
        },
        datePicker:false,
        snackbar: {
            show: false,
            message: null,
            color: null
        },
        bookingList:[{text:'Booking', value:'Booking'},{text:'PEACH', value:'PEACH'},{text:'PLUM', value:'PLUM'}], 
        e1: 1,
        disable:'',
        editedItem: {
            department:'',
            category_ids:[],
            parent_id:'',
            name:'',
            last:'',
            email:'',
            phone:'',
            status:'',
            state:'',
            city:'',
            password:'',
            is_booking:false,
            social_networks:{
                instagram:'',
                tiktok:'',
            },
            bank_account_details:{
                bank:'',
                account:'',
                clabe:'',
                card:''
            },
            birth_date:'',
            address:'',
            tax_regime_id:'',
            instagram_followers:'',
            tiktok_followers:'',
            rfc:'',
            cdf:null,
            ine:null,
            pasaporte:null,
            visa:null,
            comprobante_domicilio:null,
            tallas:[{label:'', value:''}]
        },
        state:'',
        citiesList:[]
    }),
    mounted(){
        this.$store.dispatch('state/getStates')
    },
    watch: {
        state: {
            handler () {
                this.getDataFromApi()
            },
            deep: true,
        },
    },
    computed:{
        regimes(){
            return this.$store.state.influencer_regimen.regimenes;
        },
        categories(){
            var resp = this.$store.state.category.categories
            return resp
        },
        valid(){
            if(this.editedItem.name!=''){
                return false
            }else{
                return true
            }
        },
        currentUser:{
            get(){
                return this.$store.state.currentUser.user
            }
        },
        statesList(){
            return this.$store.state.state.states
        },
        talentsAgentList(){
            if(this.editedItem.department == 'Booking'){
                return this.$store.state.user.users.filter(user=>user.role == 'Booking' || user.role == 'Booking Manager')
            }else{
                return this.$store.state.user.users.filter(user=>user.role == 'Talent Agent' || user.role == 'Talent Agent Manager')
            }
        },
    },
    methods:{
        removeTalla(index){
            this.editedItem.tallas.splice(index, 1)
        },
        addTalla(){
            console.log('perro')
            this.editedItem.tallas.push({label:'', value:''})
        },
        async uploadFile(file, fieldName) {
            if (!file) return;

            const formData = new FormData();
            formData.append('file', file);
            formData.append('field', fieldName);
            formData.append('influencer_id', this.editedItem.id);

            try {
                const response = await axios.post(
                process.env.VUE_APP_BACKEND_ROUTE + 'api/v1/sale/file',
                formData,
                { headers: { 'Content-Type': 'multipart/form-data' } }
                );

                this.editedItem[fieldName] = response.data.file; // ← Guarda solo el nombre
            } catch (error) {
                this.snackbar = {
                message: `Error al subir ${fieldName.toUpperCase()}`,
                color: 'error',
                show: true
                };
            }
        },
        clearFile(fieldName) {
            this.fileInputs[fieldName] = null;
            this.editedItem[fieldName] = null;
        },
        permissions(permission){
            if(this.currentUser.id==1){
                return true
            }else if(this.currentUser.permissions!=undefined){
                if(this.currentUser.permissions.includes(permission)){
                    return true
                }else{
                    return false
                }
            }else {
                return false
            }
        },
        getDataFromApi(){
            axios.get(process.env.VUE_APP_BACKEND_ROUTE + "api/v1/cities?state_id=" + this.state).then(response => {
                this.citiesList = response.data
            })
        },
        isMobile() {
            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true
            } else {
                return false
            }
        },
        close () {
            this.gris = false
            
            this.editedItem = {
            department:'',
            category_ids:[],
            parent_id:'',
            name:'',
            last:'',
            email:'',
            phone:'',
            status:'',
            state:'',
            city:'',
            password:'',
            is_booking:false,
            social_networks:{
                instagram:'',
                tiktok:'',
            },
            bank_account_details:{
                bank:'',
                account:'',
                clabe:'',
                card:''
            },
            birth_date:'',
            address:'',
            tax_regime_id:'',
            instagram_followers:'',
            tiktok_followers:'',
            rfc:'',
            cdf:'',
            ine:'',
            pasaporte:'',
            visa:'',
            comprobante_domicilio:'',
        },
            /*
            this.editedItem.services={
                service:'',
                value:'',
            }
            */
            this.$nextTick(() => {
                this.$emit("closeDialogItem", false);
            })
        },
        save () {
            if(this.editedItem.department == 'Booking'){
                this.editedItem.is_booking = true
            }
            if(this.editedItem.parent_id==''){
                this.editedItem.parent_id = this.currentUser.id
            }
            this.editedItem.state = this.state
            this.editedItem.role = 'Influencer'
            this.editedItem.status=1
            this.gris = true
            this.$nextTick(() => {
                axios.post(process.env.VUE_APP_BACKEND_ROUTE + "api/v1/influencers",Object.assign(this.editedItem)).then(response=>{
                    this.snackbar = {
                        message: 'Influencer creado(a) con éxito!',
                        color: 'successful',
                        show: true
                    }
                    this.close()
                }).catch(error => {
                    this.snackbar = {
                        message: error.response.data.errors.email[0],
                        color: 'error',
                        show: true
                    }
                })
            })
        },
    }
}
</script>